
define(
	'Tavanoteam.ProductSpecifications.Documents'
	, [
		'Tavanoteam.ProductSpecifications.Documents.View'
		, 'Documents.ItemDetails.View'
	]
	, function (
		DocumentsView
		, DocumentsItemDetailsView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layoutComponent = container.getComponent('Layout');

				if (layoutComponent) {
					layoutComponent.registerView('ProductDocuments', function () {
						return new DocumentsView({ container: container });
					});

					layoutComponent.registerView('ProductDocuments.ItemDetails', function () {
						return new DocumentsItemDetailsView({ container: container });
					});
				}

			}
		};
	});
